import * as React from 'react';
import {Button} from "@material-ui/core";
import {actionUserLogout} from "../../store/global";

export interface LogoutProps {
}

export interface LogoutState {
}

export class LogoutPage extends React.Component<LogoutProps, LogoutState>  {

	constructor(props: LogoutProps) {
		super(props);
	}

	render(): React.ReactNode {
		return (
			<div style={{textAlign: "center"}}>
				<Button onClick={actionUserLogout}>Logout</Button>
			</div>
		);
	}
}
